import { OWebApp, tRouteTarget } from "oweb";
import { default as appConfigs } from "@/settings/configs";
import { default as appUrlList } from "@/settings/url";
import bundles from "@/oweb.bundles";

class OWApp extends OWebApp {
	constructor() {
		super(appConfigs[ "!OW_APP_NAME" ], appConfigs, appUrlList);
	}

	get store() {
		return bundles.store(this);
	}

	get services() {
		return this.store.services;
	}

	notifyOffline() {
		!window.navigator.onLine && this.view.dialog({
			"type": "error",
			"text": "UX_LANG_YOU_ARE_OFFLINE"
		});
	}

	showLoginPage() {
		this.router.browseTo("/login", {
			"next": location.href
		}, false, true);
		return this;
	}

	showSignUpPage() {
		this.router.browseTo("/signup/one", undefined, false, true);
		return this;
	}

	showHomePage() {
		this.router.browseTo("/", undefined, false, true);
		return this;
	}

	showNotFound(target: tRouteTarget) {
		return this.showHomePage();
	}
}

let app = new OWApp();
(window as any).app = app;

export default app;
